import { useState, useEffect } from 'react';

export const useTaskFilters = (taskList, authUser, projectId = null) => {
    const [filteredList, setFilteredList] = useState([]);
    const [activeFilter, setActiveFilter] = useState('all');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        if (taskList) {
            // Step 1: Filter by Project (if ID is provided)
            let filtered = projectId 
                ? taskList.filter(task => task.projectId == projectId) 
                : [...taskList];

            // Step 2: Apply Status/Priority Filters
            if (activeFilter === 'mine') {
                filtered = filtered.filter(task => task.userId === authUser?.id);
            } else if (activeFilter === 'my-assigned') {
                filtered = filtered.filter(task => task.assignedTo === authUser?.id);
            } else if (activeFilter === 'high') {
                filtered = filtered.filter(task => task.priority === 1);
            } else if (activeFilter === 'medium') {
                filtered = filtered.filter(task => task.priority === 2);
            } else if (activeFilter === 'low') {
                filtered = filtered.filter(task => task.priority === 3);
            }

            setFilteredList(filtered);
        }
    }, [taskList, activeFilter, projectId, authUser]);

    const handleFilterChange = (filterType) => {
        setActiveFilter(filterType);
        setIsDropdownOpen(false);
    };

    return {
        filteredList,
        activeFilter,
        isDropdownOpen,
        setIsDropdownOpen,
        handleFilterChange
    };
};